/* eslint-disable no-prototype-builtins */
const isInit = () => {
  if (typeof Animation === 'undefined') {
    return true
  }
  if (!Animation.prototype.hasOwnProperty('finished')) {
    return true
  }
  if (!document.body.getAnimations) {
    return true
  }
  return false
}
export const InitWebAnimationsJsPolyfill = new Promise((res) => {
  if (isInit()) {
    console.log('InitWebAnimationsJsPolyfill ')
    import('web-animations-js/web-animations-next.min.js').then(res)
  } else {
    res(null)
  }
})
